import {
    CREATE_EPOCH_DATA_RELOAD,
    CREATE_EPOCH_DATA_RELOAD_FETCHING,
    CREATE_EPOCH_DATA_RELOAD_SUCCESS,
    CREATE_EPOCH_DATA_RELOAD_FAIL
} from 'actions/ActionTypes.js';

import AnalyticsUtil from 'utils/AnalyticsUtil';

const INITIAL_STATE = {
    data: null,
    epochDataReloadFetching: false,
    epochDataReloadFail: false
};

// ======= Fetching Handlers =======
const epochDataReloadFetching = (state, action) => {
    return {
        ...state,
        epochDataReloadFetching: true,
        epochDataReloadFail: false
    };
};

const epochDataReloadSuccess = (state, action) => {
    pushGaEventReloadStatus(action.data.status);

    return {
        data: {
            ...state.data,
            [action.calendarDate]: {
                ...action.data
            }
        },
        epochDataReloadFetching: false,
        epochDataReloadFail: false
    };
};

const epochDataReloadFail = (state, action) => {
    return {
        data: {
            ...state.data,
            [action.calendarDate]: {}
        },
        epochDataReloadFetching: false,
        epochDataReloadFail: true
    };
};

// ======= Handler Assignments =======
const handlers = {
    [CREATE_EPOCH_DATA_RELOAD_FETCHING]: epochDataReloadFetching,
    [CREATE_EPOCH_DATA_RELOAD_SUCCESS]: epochDataReloadSuccess,
    [CREATE_EPOCH_DATA_RELOAD_FAIL]: epochDataReloadFail
};

// ======= Default Action ======
export default function epochDataReload(state = INITIAL_STATE, action = {}) {
    const handler = handlers[action.type];

    if (!handler) return state;
    return handler(state, action);
}

// ======= Actions =======
export function createEpochDataReload(calendarDate, deviceId, evictCache) {
    return {
        calendarDate: calendarDate,
        deviceId: deviceId,
        type: CREATE_EPOCH_DATA_RELOAD,
        meta: {
            cacheTime: evictCache ? null : 120000
        }
    };
}

// ======= Selectors =======
export const getEpochDataReloadStatus = (state, calendarDate) => {
    if (state.epochDataReload.data && state.epochDataReload.data[calendarDate]) {
        return state.epochDataReload.data[calendarDate].status;
    } else {
        return null;
    }
};

export const getEpochDataReloadDeviceList = (state, calendarDate) => {
    if (state.epochDataReload.data && state.epochDataReload.data[calendarDate]) {
        return state.epochDataReload.data[calendarDate].deviceList;
    } else {
        return null;
    }
};

export const isEpochDataReloadFetching = (state) => {
    return state.epochDataReload.epochDataReloadFetching;
};

export const didEpochDataReloadFail = (state) => {
    return state.epochDataReload.epochDataReloadFail;
};

// Tracking this metric here instead of in the component to avoid redundant reporting due to how the render method works in React
const pushGaEventReloadStatus = (status) => {
    AnalyticsUtil.push({
        event: 'track_event',
        category: 'Epoch Data Reloading',
        action: 'Reload status from the API',
        label: status
    });
};
